/**
* @file 公共组件-自定义搜索
* */
<template>
  <div id="customSearch">
    <!--顶部部分：左侧搜索和右侧按钮组-->
    <div class="customTable-top" :class="{ grouping: copySearch && copySearch.length > 0 }">
      <!--组合查询-->
      <div class="grouping-field" v-if="copySearch && copySearch.length > 0">
        <div v-for="(item, index) in copySearch" :key="item.field" class="grouping-field-item"
             v-show="!item.showIf || checkShowIf(item.showIf)"
             style="-ms-grid-column: 1" :class="item.type == 'datetime' ? 'datetime' : ''" :style="item.type == 'datetime'
              ? {
                'grid-column-start': (index + 1) % 4,
                'grid-column-end': ((index + 1) % 4) + 2,
                'min-width': showLabel ? '280px' : '200px',
              }
              : { 'min-width': showLabel ? '220px' : '180px' }
            ">
          <span v-if="showLabel" class="grouping-field-label" :style="{ width: labelWidth + 'px' }">
            {{ showLabel ? (item.name ? item.name + ":" : null) : "" }}
          </span>

          <div class="grouping-field-value">
            <!-- 机构id     organizationId      -->
            <el-select v-if="
              item.type == 'organizationId' &&
              mixinUserInfo &&
              mixinUserInfo.organizationType == 1 &&
              hasOrganization
            " v-model="item.value" filterable :placeholder="'选择' + item.name" @change="queryCompanyFn"
                       :clearable="!organizationDefault">
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
              </el-option>
            </el-select>
            <!-- 机构id     channnelID      -->
            <el-select :disabled="disableChannel" v-if="item.type == 'channelId'" v-model="item.value" filterable
                       :placeholder="'选择' + item.name" @change="queryFn" :clearable="true">
              <el-option v-for="val in organizationChannel" :key="val.channelId" :value="val.channelId"
                         :label="val.channelName">
              </el-option>
            </el-select>
            <el-select v-else-if="item.type == 'select' && item.remoteOption" filterable remote
                       :disabled="item.disabled" v-model="item.value" :placeholder="'请选择' + item.name"
                       @change="queryFn"
                       clearable :remote-method="(value) => {
                remoteMethod(value, item.remoteOption)
              }">
              <el-option v-for="(val, i) in optionData" :key="i" :label="item.props
                  ? val[item.props.label]
                  : val.label
                    ? val.label
                    : val
                " :value="item.props
                    ? val[item.props.value]
                    : val.value
                      ? val.value
                      : val
                  ">
              </el-option>
            </el-select>
            <el-select v-else-if="item.type == 'select'" :filterable="item.filterable" :disabled="item.disabled"
                       v-model="item.value" :placeholder="'请选择' + item.name" @change="queryFn" clearable>
              <el-option v-for="(val, i) in item.option" :key="i" :label="item.props
                  ? val[item.props.label]
                  : val.label
                    ? val.label
                    : val
                " :value="item.props
                    ? val[item.props.value]
                    : val.value
                      ? val.value
                      : val
                  ">
              </el-option>
            </el-select>

            <el-cascader v-if="item.type == 'cascader'" :placeholder="'请选择' + item.name"
                         v-model="item.value" :options="item.option" filterable :props="item.props" @change="queryFn"
                         :clearable="true"></el-cascader>

            <!--单选-->
            <el-radio-group v-if="item.type == 'radio'" v-model="item.value" @change="radioChange(item)"
                            class="custom-search-radio">
              <el-radio v-for="(val, i) in item.option" :key="i" :label="item.prop && item.prop.value
                  ? val[item.prop.value]
                  : val.value
                    ? val.value
                    : ''
                ">
                {{
                  item.prop && item.prop.label
                      ? val[item.prop.label]
                      : val.label
                }}
              </el-radio>
            </el-radio-group>

            <!-- 单选组 -->
            <el-radio-group v-if="item.type == 'radioGroup'" v-model="item.value" @change="radioGroupChange">
              <el-radio-button v-for="(val, i) in item.option" :key="i" :label="item.prop && item.prop.value
                  ? val[item.prop.value]
                  : val.value
                    ? val.value
                    : ''
                ">
                {{
                  item.prop && item.prop.label
                      ? val[item.prop.label]
                      : val.label
                }}
              </el-radio-button>
            </el-radio-group>

            <!--输入框-->
            <el-input v-if="item.type == 'input' " v-model="item.value" :placeholder="'搜索' + item.name"/>

            <el-date-picker style="width: 100%" v-model="item.value" v-else-if="item.type == 'date'"
                            :type="item.dateType" :placeholder="'选择' + item.name" :picker-options="{
                disabledDate(time) {
                  const now = new Date();
                  const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                  return time.getTime() > from;
                },
              }" @change="queryFn">
            </el-date-picker>

            <el-date-picker @change="queryFn" style="width: 100%" :clearable="item.clearable"
                            v-else-if="item.type == 'daytime'" value-format="timestamp" v-model="item.value"
                            type="daterange"
                            :picker-options="{
                disabledDate(time) {
                  return item.disabledDate ? time.getTime() > Date.now() : false;
                },
              }" range-separator="-" :start-placeholder="item.name + '起'" :end-placeholder="item.name + '止'">
            </el-date-picker>

            <!--时间-->
            <div style="display: flex; align-items: center" class="custom-picker" v-if="item.type == 'datetime'">
              <!-- <el-date-picker v-model="item.value" type="datetimerange" range-separator="至" :start-placeholder="item.name+'起'" :end-placeholder="+'止'"></el-date-picker> -->
              <el-date-picker type="datetime" v-model="item.value[0]" @change="datetimeChange(item.name)"
                              value-format="timestamp" format="yyyy-MM-dd HH:mm" prefix-icon="''" :picker-options="{
                  disabledDate(time) {
                    return item.disabledDate ? time.getTime() > Date.now() : false;
                  },
                }" :placeholder="`${item.name}起`">
              </el-date-picker>
              <!-- -  -->
              <el-date-picker type="datetime" v-model="item.value[1]" @change="datetimeChange(item.name)"
                              value-format="timestamp" format="yyyy-MM-dd HH:mm" prefix-icon="''"
                              default-time="23:59:59"
                              :picker-options="{
                  disabledDate(time) {
                    return item.disabledDate ? time.getTime() > Date.now() : false;
                  },
                }" :placeholder="`${item.name}止`">
              </el-date-picker>
            </div>
          </div>
        </div>

        <slot name="search-append"></slot>

        <div class="grouping-button" :style="{ marginLeft: showLabel ? labelWidth + 'px' : '0px' }">
          <el-button type="primary" @click="queryFn">查询</el-button>
          <el-button @click="resetFn">重置</el-button>
        </div>

        <div class="custom-search-button">
          <div>
            <slot name="custom-search-button-left"></slot>
          </div>
          <div v-if="serchTipsRight" class="serchTipsRight">
            {{ serchTipsRight }}
          </div>
          <div>
            <!--按钮组插槽-->
            <slot></slot>
          </div>
        </div>
      </div>

      <!--顶部左侧插槽，仅在无搜索项时，才能有改插槽-->
      <div v-else style="
          display: flex;
          align-items: center;
          justify-content: space-between
        ">
        <slot name="top-left"></slot>
        <div style="align-self: flex-end">
          <slot name="top-right"></slot>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "customSearch",
  props: {
    /**
     * 配置项。具体配置项目如下：
     * type: 'select', // 类型，必传，类型有select、input、radio
     * field: 'name',// 字段，必传
     * name: '名称', // 字段名，必传
     * value: '', // 字段值，非必传，设置值则表示该搜索项的默认选中值
     * option: [], // select类型的下拉选择项，type为select时必传
     * prop: { // 下拉选择项的自定义字段，默认是label,value,非必传
     *     label: 'label',
     *     value: 'status',
     * }
     * dateProp: { // 类型为datetime配置搜索字段使用，默认是 startTime 和 endTime
     *   start: 'startTime',
     *   end: 'endTime'
     * }
     * sort: false // 是否是排序字段，true-是，false-不是。默认为false,非必传
     */
    showLabel: {
      default() {
        return false;
      },
    },
    search: {
      default() {
        return [];
      },
    },
    serchTipsRight: {
      default() {
        return "";
      },
    },
    hasOrganization: {
      default() {
        return false;
      },
    },
    hasChannel: {
      default() {
        return false;
      },
    },
    organizationId: {
      default() {
        return "";
      },
    },
    organizationDefault: {
      default() {
        return false;
      },
    },
    /**
     * 组合查询的label宽度
     */
    labelWidth: {
      default() {
        return 100;
      },
    },
    /**
     * 组合查询的label宽度
     */
    initSearch: {
      default() {
        return true;
      },
    },
  },
  computed: {
    disableChannel() {
      // 分机构默认不禁用
      if (this.mixinUserInfo.organizationType === 2) {
        return false;
      }
      const find = this.copySearch.find(
          (item) => item.field === "organizationId"
      );
      if (find) {
        return find.value === "";
      } else {
        return true;
      }
    },

  },
  data() {
    return {
      // 搜索参数配置项
      copySearch: [],
      // 生成的参数
      params: {},
      // 当前选中的搜索参数字段
      searchField: "",
      // 搜索参数项
      searchObj: {},
      optionData: [],
      timer: null
    };
  },
  watch: {
    search: {
      handler(newVal) {
        this.copySearch = this.$utils.deepCopyFn(newVal);
      },
      deep: true,
    },
  },

  async created() {
    if (this.search && this.search.length > 0) {
      if (
          this.hasChannel &&
          this.mixinUserInfo &&
          this.mixinUserInfo.platformType == 3
      ) {
        this.search = this.search || [];
        if (this.search.findIndex((item) => item.type == "channelId") < 0) {
          this.search.unshift({
            type: "channelId",
            field: "channelId",
            name: "归属渠道",
            value: "",
          });
        }
      }

      if (
          this.hasOrganization &&
          this.mixinUserInfo &&
          this.mixinUserInfo.organizationType == 1
      ) {
        this.mixinOrganizations();
        this.search = this.search || [];
        if (
            this.search.findIndex((item) => item.type == "organizationId") < 0
        ) {
          this.search.unshift({
            type: "organizationId",
            field: "organizationId",
            name: "机构名称",
            value: this.organizationId
                ? this.organizationId
                : this.organizationDefault
                    ? this.mixinUserInfo.organizationId
                    : "",
          });
        }
      }
      this.copySearch = this.search;
      setTimeout(() => {
        this.copySearch = this.$utils.deepCopyFn(this.search);
      }, 1000);

      this.getQureyFn();
    }

    this.initSearch && this.queryFn();
  },
  methods: {
    remoteMethod(val, option) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        let {code, data} = await this.$axios.get(option.url, {name: val});
        if (code == 1) {
          this.optionData = data.map(item => {
            return {
              label: item[option.labelKey],
              value: item[option.valueKey]
            }
          })
        }
      }, 500)
    },
    async getQureyFn() {
      const organization = this.copySearch.find(
          (item) => item.type === "organizationId"
      );

      const findIndex = this.copySearch.findIndex(
          (item) => item.field === "ticketSellerId"
      );
      if (findIndex !== -1) {
        const list = await this.mixinGetAdmins({
          organizationId: (organization && organization.value) || "",
        });
        this.copySearch.forEach((item) => {
          if (item.field === "ticketSellerId") {
            item.option = list;
            item.value = "";
          }
        });
      }

      const findIndex2 = this.copySearch.findIndex(
          (item) => item.field === "lineId"
      );
      if (findIndex2 !== -1) {
        const list = await this.mixinGetLines({
          organizationId: (organization && organization.value) || "",
        });
        this.copySearch.forEach((item) => {
          if (item.field === "lineId") {
            item.option = list.map((item) => {
              return {
                ...item,
                stationName: item.startStationName + "-" + item.endStationName,
              };
            });
            item.value = "";
          }
        });
      }

      const findIndex3 = this.copySearch.findIndex(
          (item) => item.field === "channelId"
      );
      if (findIndex3 !== -1) {
        if (this.mixinUserInfo.organizationType == 2) {
          this.mixinOrganizationChannel({
            organizationId: this.mixinUserInfo.organizationId,
          });
        } else {
          organization &&
          organization.value &&
          this.mixinOrganizationChannel({
            organizationId: organization.value,
          });
        }
        this.copySearch.forEach((item) => {
          if (item.field === "channelId") {
            item.value = "";
          }
        });
      }
    },
    /* 时间变化 使单选框组归零 这是狗屎代码 */
    datetimeChange(name) {
      let qeury = () => {
        this.copySearch.forEach((item) => {
          if (item.type == "radioGroup" && item.field == "timeType") {
            item.value = "";
          }
        });
        this.queryFn();
      };
      this.copySearch.forEach((item) => {
        if (item.type == "datetime" && item.name == name) {
          if (item.value && item.value[0] && item.value[1]) {
            if (item.value[1] < item.value[0]) {
              this.$message.warning("开始时间选择时不能大于结束时间！");
              item.value = [];
              return;
            } else {
              qeury();
            }
          } else {
            qeury();
          }
        }
      });
    },

    /* 单选框组变化 使时间归零 这是狗屎代码 */
    radioGroupChange() {
      this.copySearch.forEach((item) => {
        if (item.type == "datetime" && item.field == "time") {
          item.value = [];
        }
      });
      this.queryFn();
    },
    async queryCompanyFn() {
      this.getQureyFn();
      this.copySearch.forEach((item) => {
        let startTime =
            item.dateProp && item.dateProp.start
                ? item.dateProp.start
                : "startTime";
        let endTime =
            item.dateProp && item.dateProp.end ? item.dateProp.end : "endTime";
        if (item.type == "date") {
          this.params[item.field] = item.value ? Math.floor(item.value / 1000) : ""
        } else if (item.type == "datetime") {
          if (item.value && item.value[0]) {
            this.params[startTime] =
                item.value && item.value[0]
                    ? Math.floor(item.value[0] / 1000)
                    : "";
          } else {
            this.params[startTime] = "";
          }
          if (item.value && item.value[1]) {
            this.params[endTime] =
                item.value && item.value[1]
                    ? Math.floor(item.value[1] / 1000)
                    : "";
          } else {
            this.params[endTime] = "";
          }
          delete this.params[item.field];
        } else if (item.type == "daytime") {
          if (item.value && item.value[0] && item.value[1]) {
            this.params["start" + item.field] = Math.floor(
                item.value[0] / 1000
            );
            this.params["end" + item.field] =
                Math.floor(item.value[1] / 1000) + 24 * 60 * 60 - 1;
          } else {
            this.params.startTime = "";
            this.params.endTime = "";
            item.value = [];
          }
          delete this.params[item.field];
        } else {
          this.params[item.field] = item.value;
        }
      });

      this.params.page = 1;

      this.paramsFn();
    },
    /* 查询 */
    queryFn(value) {
      console.log('value', value)
      console.log('this.copySearch', this.copySearch)
      this.copySearch.forEach((item) => {
        let startTime =
            item.dateProp && item.dateProp.start
                ? item.dateProp.start
                : "startTime";
        let endTime =
            item.dateProp && item.dateProp.end ? item.dateProp.end : "endTime";
        if (item.type == "date") {
          this.params[item.field] = item.value ? Math.floor(item.value / 1000) : ""
        } else if (item.type == "datetime") {
          if (item.value && item.value[0]) {
            this.params[startTime] =
                item.value && item.value[0]
                    ? Math.floor(item.value[0] / 1000)
                    : "";
          } else {
            this.params[startTime] = "";
          }
          if (item.value && item.value[1]) {
            this.params[endTime] =
                item.value && item.value[1]
                    ? Math.floor(item.value[1] / 1000)
                    : "";
          } else {
            this.params[endTime] = "";
          }
          delete this.params[item.field];
        } else if (item.type == "daytime") {
          if (item.value && item.value[0] && item.value[1]) {
            this.params["start" + item.field] = Math.floor(
                item.value[0] / 1000
            );
            this.params["end" + item.field] =
                Math.floor(item.value[1] / 1000) + 24 * 60 * 60 - 1;
          } else {
            this.params.startTime = "";
            this.params.endTime = "";
            item.value = [];
          }
          delete this.params[item.field];
        } else if (item.type == "cascader") {
          this.params[item.field] = item.value[1] || '';
        } else {
          this.params[item.field] = item.value;
        }
      });
      this.params.page = 1;

      this.paramsFn();
    },

    // /* 单项查询-搜索项发生变化 */
    // singleFieldFn(val) {
    //   this.searchField = val;
    //   this.searchObj = this.copySearch.find((value) => value.field == val);
    // },

    /* 组合查询-重置 */
    resetFn() {
      this.copySearch.forEach((item, index) => {
        let val = this.search.find((value) => value.field == item.field);
        item.value = val.value;
        this.params[item.field] = val.value;
        if (item.type == "datetime") {
          if (item.dateProp) {
            this.params[item.dateProp.end] = "";
            this.params[item.dateProp.start] = "";
            item.value = [];
            this.params[item.field] = [];
          } else {
            this.params.startTime = item.defaultDays ? (new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * item.defaultDays) / 1000 : "";
            this.params.endTime = item.defaultDays ? (new Date().setHours(23, 59, 59, 0) / 1000) : "";
            item.value = item.defaultDays ? [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * item.defaultDays, new Date().setHours(23, 59, 59, 0)] : [];
          }
        } else if (item.type == "daytime") {
          if (item.clearable === true) {
            this.params["start" + item.field] = "";
            this.params["end" + item.field] = "";
            item.value = [];
          } else {
            this.params["start" + item.field] = Math.floor(
                this.search[index].value[0] / 1000
            );
            this.params["end" + item.field] =
                Math.floor(this.search[index].value[1] / 1000) + 24 * 60 * 60 - 1;
          }

          delete this.params[item.field];
        }
      });
      this.$emit("resetFn");
      this.paramsFn();
      this.getQureyFn();
    },

    /* 搜索参数抛出 */
    paramsFn() {
      let params = this.$utils.deepCopyFn(this.params);
      console.log('params', params)
      this.$emit("paramsFn", params);
    },

    /* 单选项发生变化 */
    radioChange(item) {
      if (item.sort) {
        this.copySearch.forEach((val) => {
          if (val.sort && val.field !== item.field) {
            val.value = "";
          }
        });
        this.queryFn();
      }
    },
    /**
     * 检查字段是否应该显示
     * @param {Object} showIf - 显示条件配置 { field: '依赖字段', value: '依赖值' }
     */
    checkShowIf(showIf) {
      if (!showIf) return true;
      // 存在筛选条件
      // 不存在依赖选项
      const dependField = this.copySearch.find(item => item.field === showIf.field);
      if (!dependField) return true;
      // 存在依赖选项
      // 支持数组形式的多值匹配
      if (Array.isArray(showIf.value)) {
        return showIf.value.includes(dependField.value);
      }
      return dependField.value === showIf.value;
    },
  },

};
</script>

<style lang="less">
#customSearch {
  .customTable-top {
    .single-field {
      display: flex;
      align-items: center;
      justify-content: center;
      /* 下拉选择器样式修改 */

      .ivu-select {
        width: 110px;
      }

      .single-field-value {
        margin-left: 8px;

        .ivu-select {
          width: 200px;
        }
      }

      /* 普通输入框样式修改 */

      .ivu-input {
        height: 28px;
        font-size: 14px;
        width: 200px;
        padding: 4px 12px;
      }

      .single-field-button {
        margin-left: 16px;
      }
    }

    .grouping-field {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 12px;

      .grouping-field-item {
        padding: 6px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        flex-shrink: 0;

        .grouping-field-label {
          padding-right: 8px;
          text-align: right;
          color: #606266;
          box-sizing: border-box;
          white-space: nowrap;
          font-weight: 500;
        }

        .grouping-field-value {
          flex: 1;
          min-width: 140px;

          .el-select {
            width: 100%;
          }
          
          .el-input__inner,
          .el-select .el-input__inner {
            border-radius: 6px;
          }
        }
      }
      
      .grouping-field-item.datetime {
        .grouping-field-value {
          min-width: 280px;
        }
      }

    }

    .grouping-field-bottom {
      padding: 0 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .grouping-button {
      display: flex;
      align-items: center;
      padding: 8px 6px;
      gap: 10px;
    }

    .grouping-field + .grouping-field-bottom {
      margin-top: 6px;
    }

    .grouping-field-bottom.flexEnd {
      justify-content: flex-end;
    }

    /* 单选按钮组 */

    .custom-search-button {
      padding: 6px;
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .serchTipsRight {
      flex-grow: 1;
      margin: 0 10px;
      font-weight: bold;
      text-align: right;
    }
  }

  .customTable-top.grouping {
    background-color: #f8fafc;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px 16px 16px;
  }

  .custom-picker {
    width: 100%;
    min-width: 240px;
    display: flex;
    justify-content: space-between;
    gap: 8px;

    .el-input--prefix .el-input__inner {
      width: 100%;
      padding: 0 8px;
    }

    .el-date-editor {
      width: 49%;
    }
  }
}
</style>
